import { HelpCircle } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Card } from '@/components/ui/card'

export interface ClarificationSummaryProps {
  context: string | null
  items: { question: string; answer: string | null }[]
}

/** A stop the agent made, kept in the conversation as a read-only record of its questions and the answers. */
export function ClarificationSummary({ context, items }: ClarificationSummaryProps) {
  const { t } = useTranslation()
  return (
    <Card className="my-2 flex flex-col gap-3 p-4 text-sm">
      <p className="flex items-center gap-2 font-medium text-foreground">
        <HelpCircle className="size-4 shrink-0 text-primary" aria-hidden />
        {t('schemaAgent.clarification.askedTitle')}
      </p>
      {context && <p className="text-muted-foreground">{context}</p>}
      <dl className="flex flex-col gap-2">
        {items.map(item => (
          <div key={item.question}>
            <dt className="font-medium text-foreground">{item.question}</dt>
            <dd className="text-muted-foreground">
              {item.answer?.trim() || t('schemaAgent.clarification.noAnswer')}
            </dd>
          </div>
        ))}
      </dl>
    </Card>
  )
}
